<div class="impacts-header">
  <div class="impacts-title">Impacts</div>
  <div class="impacts-line"></div>
  <div class="impacts-subtitle">Driving positive change is a foundational aspect of the company's mission. You are
    helping us to drive this change. Take a look at what we've been able to accomplish together.</div>
</div>
<div *ngIf="!impacts">
  <app-spinner></app-spinner>
</div>
<div *ngIf="impacts" class="impacts-main">
  <div *ngIf="pageVariant === 'default'" class="impacts-content">
    <tyt-company-impact-item *ngFor="let item of impactsFirstSection" [impact]="item" [showLearnMore]="showLearnMore"></tyt-company-impact-item>
    <div *ngIf="showEmbeddedOffers" class="impacts-embedded-offer">
      <tyt-embedded-offer-set
        [offerSetID]="offerSetID"
        actBlueLink="https://secure.actblue.com/donate/tytnetwork_ad"
        >
      </tyt-embedded-offer-set>
    </div>
    <tyt-company-impact-item *ngFor="let item of impactsSecondSection" [impact]="item"></tyt-company-impact-item>
  </div>

  <div *ngIf="pageVariant === 'videoHeroLayout'">

    <div class="hero-block">
      <div class="hero-video">
        <ng-container *ngIf="isHeroVideoYouTube">
          <div id="youtube-hero">
            <iframe [src]="heroVideoYouTubeEmbedUrl"
              title="YouTube video player" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
          </div>
        </ng-container>
        <ng-container *ngIf="!isHeroVideoYouTube">
          <video [src]="heroVideoURL" id="HeroVideoPlayer" controls></video>
        </ng-container>
        <div class="hero-content">
          <h3>{{heroVideoTitle}}</h3>
          <p>{{heroVideoDescription}}</p>
        </div>
      </div>
      <tyt-embedded-offer-set
        [offerSetID]="offerSetID"
        actBlueLink="https://secure.actblue.com/donate/tytnetwork_ad"
        >
      </tyt-embedded-offer-set>
    </div>

    <div class="impacts-content">
      <tyt-company-impact-item *ngFor="let item of impacts" [impact]="item" [showLearnMore]="showLearnMore"></tyt-company-impact-item>
    </div>

  </div>

</div>
<tyt-call-to-action [callToAction]="c2a"></tyt-call-to-action>
